<div class="holder" (click)="openProfile()" [ngClass]="{ active: !isInvite }">
  <div class="segment info">
    <ng-container *ngIf="entry.type === 'invite'">
      <img alt src="/assets/images/verify-email.svg" class="invite-picture" />
      {{ entry.entry.first_name }} {{ entry.entry.name }}
    </ng-container>
    <ng-container *ngIf="entry.type === 'participant'">
      <profile-picture [user]="entry.entry.user"></profile-picture>
      <name-tag [user]="entry.entry.user" [showOrg]="false"></name-tag>
    </ng-container>
  </div>
  <div class="segment small status d-xs-none d-md-block">
    <ng-container *ngIf="isInvite">Invited</ng-container>
  </div>
  <div class="segment organization small d-xs-none d-md-block">
    <ng-container *ngIf="entry.type === 'invite'">
      {{ entry.entry.organization || '' }}
    </ng-container>
    <ng-container *ngIf="entry.type === 'participant'">
      {{ entry.entry.user.organization }}
    </ng-container>
  </div>
  <div class="segment role small d-xs-none d-md-block">
    <ng-container *ngIf="isModerator">Moderator</ng-container>
    <ng-container *ngIf="isParticipant">Participant</ng-container>
    <ng-container *ngIf="isExternalEvaluator">External Evaluator</ng-container>
  </div>
  <div class="segment ideas d-xs-none d-md-block">
    <img
      alt
      *ngFor="let idea of ideas"
      [src]="ideaThumbnail(idea)"
      (click)="ideaClicked(idea, $event)"
      title="{{ idea.title }}"
      class="idea" />
  </div>
  <div class="segment actions">
    <ng-container *ngIf="!isInvite">
      <button class="btn btn-primary" (click)="directMsg($event)">
        <i class="icon-send-msg"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="isInvite">
      <button
        class="btn btn-danger"
        (click)="uninvite($event)"
        [disabled]="!canUnInvite">
        <i class="icon-remove-person"></i>
      </button>
    </ng-container>
  </div>
</div>
